import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { updateAuthToken } from './components/Common/axiosInstance';

let tokenFromUrl = new URLSearchParams(window.location.search).get("token");
if(!tokenFromUrl){
    tokenFromUrl = window.localStorage.getItem("token");
    if(tokenFromUrl)updateAuthToken(tokenFromUrl);
}
else{
    updateAuthToken(tokenFromUrl)
}
ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
